"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TooltipPosition = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("../../Components/styles/color"));
var _Text = _interopRequireDefault(require("../../SharedComponents/Typography/Text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-8adhez-0"
})(["display:flex;position:relative;flex-direction:column;min-width:20px;"]);
var ChildrenContainer = _styledComponents["default"].div.withConfig({
  displayName: "ChildrenContainer",
  componentId: "sc-8adhez-1"
})(["display:flex;position:relative;"]);
/**
 * {flex-direction: column} is to help support for ie 11 issues
 */
var TooltipContainer = _styledComponents["default"].div.attrs(function (_ref) {
  var tooltipCoordinates = _ref.tooltipCoordinates,
    childDimensions = _ref.childDimensions,
    tooltipDimensions = _ref.tooltipDimensions,
    tooltipAbsolutePosition = _ref.tooltipAbsolutePosition;
  // tooltip position relative to child container
  var xPosition = childDimensions.width > tooltipDimensions.width ? getValueInsideRange(tooltipCoordinates.x, 0, childDimensions.width - tooltipDimensions.width) : tooltipCoordinates.x;
  var yPosition = childDimensions.height > tooltipDimensions.height ? getValueInsideRange(tooltipCoordinates.y, 0, childDimensions.height - tooltipDimensions.height) : tooltipCoordinates.y;
  return {
    style: _objectSpread({
      left: "".concat(xPosition, "px"),
      top: "".concat(yPosition, "px")
    }, tooltipAbsolutePosition)
  };
}).withConfig({
  displayName: "TooltipContainer",
  componentId: "sc-8adhez-2"
})(["flex-direction:column;display:flex;position:absolute;width:max-content;max-width:300px;background:", ";border-radius:4px;padding:4px 8px;margin-bottom:9px;z-index:16;visibility:hidden;opacity:0;transition:visibility .1s ease-out,opacity .3s ease;-webkit-transition:visibility .1s ease-out,opacity .3s ease;-moz-transition:visibility .1s ease-out,opacity .3s ease-out;-ms-transition:visibility .1s ease-out,opacity .3s ease-out;-ms-transition:visibility .1s ease-out,opacity .3s ease-out;", ";"], _color["default"].grey800, function (props) {
  return props.isVisible && "\n    visibility: visible;\n    opacity: 0.9;\n  ";
});
var Arrow = _styledComponents["default"].div.attrs(function (_ref2) {
  var _objectSpread2;
  var arrowCoordinates = _ref2.arrowCoordinates,
    tooltipDimensions = _ref2.tooltipDimensions,
    arrowAbsolutePosition = _ref2.arrowAbsolutePosition;
  // position relative to tooltip container including padding
  var xPosition = getValueInsideRange(arrowCoordinates.x, 8, tooltipDimensions.width - 24);
  var yPosition = getValueInsideRange(arrowCoordinates.y, 4, tooltipDimensions.height - 20);
  return {
    style: _objectSpread((_objectSpread2 = {
      left: "".concat(xPosition, "px"),
      top: "".concat(yPosition, "px")
    }, _defineProperty(_objectSpread2, arrowAbsolutePosition.borderPosition, "8px solid ".concat(_color["default"].grey800)), _defineProperty(_objectSpread2, arrowAbsolutePosition.placement, '-7px'), _objectSpread2), arrowAbsolutePosition.left && {
      left: arrowAbsolutePosition.left
    })
  };
}).withConfig({
  displayName: "Arrow",
  componentId: "sc-8adhez-3"
})(["display:flex;position:absolute;width:0;height:0;", ""], function (props) {
  return [TooltipPosition.TOP, TooltipPosition.BOTTOM].includes(props.position) ? "\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;" : "\n        border-top: 8px solid transparent;\n        border-bottom: 8px solid transparent;";
});
var getValueInsideRange = function getValueInsideRange(value, minValue, maxValue) {
  return value < minValue ? minValue : value > maxValue ? maxValue : value;
};
var TooltipPosition = {
  TOP: 'top',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
  LEFT: 'left',
  LEFT_TOP: 'leftTop',
  LEFT_BOTTOM: 'leftBottom',
  RIGHT: 'right',
  RIGHT_TOP: 'rightTop',
  RIGHT_BOTTOM: 'rightBottom'
};
exports.TooltipPosition = TooltipPosition;
var Tooltip = function Tooltip(_ref3) {
  var label = _ref3.label,
    children = _ref3.children,
    position = _ref3.position,
    sticky = _ref3.sticky,
    hidden = _ref3.hidden;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var _useState3 = (0, _react.useState)(TooltipPosition.TOP),
    _useState4 = _slicedToArray(_useState3, 2),
    tooltipPosition = _useState4[0],
    setTooltipPosition = _useState4[1];
  var _useState5 = (0, _react.useState)({
      x: 0
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    arrowCoordinates = _useState6[0],
    setArrowCoordinates = _useState6[1];
  var _useState7 = (0, _react.useState)({
      x: 0
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    tooltipCoordinates = _useState8[0],
    setTooltipCoordinates = _useState8[1];
  var _useState9 = (0, _react.useState)({
      width: 0,
      height: 0
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    tooltipDimensions = _useState10[0],
    setTooltipDimensions = _useState10[1];
  var _useState11 = (0, _react.useState)({
      width: 0,
      height: 0
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    childDimensions = _useState12[0],
    setChildDimensions = _useState12[1];
  var _useState13 = (0, _react.useState)({}),
    _useState14 = _slicedToArray(_useState13, 2),
    tooltipAbsolutePosition = _useState14[0],
    setTooltipAbsolutePosition = _useState14[1];
  var _useState15 = (0, _react.useState)({}),
    _useState16 = _slicedToArray(_useState15, 2),
    arrowAbsolutePosition = _useState16[0],
    setArrowAbsolutePosition = _useState16[1];
  var tooltipRef = (0, _react.useRef)(null);
  var childRef = (0, _react.useRef)(null);
  var arrowRef = (0, _react.useRef)(null);
  var handleMouseMove = function handleMouseMove(e) {
    var isOverChild = childRef.current.contains(e.target);
    if (isOverChild) {
      var tooltipRect = tooltipRef.current.getBoundingClientRect();
      var childRect = e.target.getBoundingClientRect();

      // mouse position relative to the ChildrenContainer
      var mouseX = Math.floor(e.clientX - childRect.left);

      // tooltip left/right positions relative to the ChildrenContainer
      var tooltipLeft = tooltipRect.left - childRect.left;
      var tooltipRight = tooltipRect.right - childRect.left;
      var tooltipWidth = tooltipRect.width;
      var childWidth = childRect.width;
      if (mouseX > tooltipLeft && mouseX < tooltipRight) {
        setArrowCoordinates({
          x: mouseX - tooltipLeft - 8
        });
      }
      if (childWidth > tooltipWidth) {
        if (mouseX > tooltipRight - 24) {
          setTooltipCoordinates({
            x: mouseX - tooltipWidth + 24
          });
        } else if (mouseX < tooltipLeft + 24) {
          setTooltipCoordinates({
            x: mouseX - 24
          });
        }
      }
    }
  };
  var handleMouseOver = function handleMouseOver(event) {
    var isInsideChildren = childRef.current.contains(event.target);
    if (childRef.current) {
      setShowTooltip(isInsideChildren);
    }
  };

  /* eslint-disable */
  (0, _react.useEffect)(function () {
    sticky && document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('resize', onResize);
    return function () {
      sticky && document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('resize', onResize);
    };
  }, []);
  /* eslint-enable */

  (0, _react.useEffect)(function () {
    var child = childRef.current || {
      clientWidth: 0,
      clientHeight: 0
    };
    var tooltip = tooltipRef.current || {
      clientWidth: 0,
      clientHeight: 0
    };
    setTooltipDimensions({
      width: tooltip.clientWidth,
      height: tooltip.clientHeight
    });
    setChildDimensions({
      width: child.clientWidth,
      height: child.clientHeight
    });
  }, [childRef, tooltipRef]);
  var onResize = function onResize() {
    var child = childRef.current;
    setChildDimensions({
      width: child.clientWidth,
      height: child.clientHeight
    });
  };

  // Tooltip Position Along Child Component
  (0, _react.useEffect)(function () {
    if (!hidden) {
      var childCenterX = childDimensions.width / 2;
      var childCenterY = childDimensions.height / 2;
      var tooltipCenterX = tooltipDimensions.width / 2;
      var tooltipCenterY = tooltipDimensions.height / 2;
      if (position) {
        if (position.includes(TooltipPosition.BOTTOM)) {
          setTooltipPosition(TooltipPosition.BOTTOM);
        } else if (position.includes(TooltipPosition.LEFT)) {
          setTooltipPosition(TooltipPosition.LEFT);
        } else if (position.includes(TooltipPosition.RIGHT)) {
          setTooltipPosition(TooltipPosition.RIGHT);
        }
        switch (position) {
          // TOP - BOTTOM //
          case TooltipPosition.TOP:
          case TooltipPosition.BOTTOM:
            {
              setTooltipCoordinates({
                x: childCenterX - tooltipCenterX
              });
              setArrowCoordinates({
                x: tooltipCenterX - 8
              });
              break;
            }
          case TooltipPosition.TOP_LEFT:
          case TooltipPosition.BOTTOM_LEFT:
            {
              setTooltipCoordinates({
                x: 0
              });
              setArrowCoordinates({
                x: 0
              });
              break;
            }
          case TooltipPosition.TOP_RIGHT:
          case TooltipPosition.BOTTOM_RIGHT:
            {
              setTooltipCoordinates({
                x: childDimensions.width - tooltipDimensions.width
              });
              setArrowCoordinates({
                x: tooltipDimensions.width - 8
              });
              break;
            }
          // LEFT - RIGHT //
          case TooltipPosition.LEFT:
          case TooltipPosition.RIGHT:
            {
              setTooltipCoordinates({
                y: childCenterY - tooltipCenterY
              });
              setArrowCoordinates({
                y: tooltipCenterY - 8
              });
              break;
            }
          case TooltipPosition.LEFT_TOP:
          case TooltipPosition.RIGHT_TOP:
            {
              setTooltipCoordinates({
                y: 0
              });
              setArrowCoordinates({
                y: 0
              });
              break;
            }
          case TooltipPosition.LEFT_BOTTOM:
          case TooltipPosition.RIGHT_BOTTOM:
            {
              setTooltipCoordinates({
                y: childDimensions.height - tooltipDimensions.height
              });
              setArrowCoordinates({
                y: tooltipDimensions.height - 8
              });
              break;
            }
          default:
            {
              // TOP position
              setTooltipCoordinates({
                x: childCenterX - tooltipCenterX
              });
              setArrowCoordinates({
                x: tooltipCenterX - 8
              });
            }
        }
      } else {
        setTooltipCoordinates({
          x: childCenterX - tooltipCenterX
        });
        setArrowCoordinates({
          x: tooltipCenterX - 8
        });
      }
    }
  }, [position, childDimensions, tooltipDimensions, hidden]);

  // Tooltip Position Around Child Component
  (0, _react.useEffect)(function () {
    switch (tooltipPosition) {
      case TooltipPosition.TOP:
        {
          setTooltipAbsolutePosition({
            bottom: "".concat(childDimensions.height, "px"),
            top: 'auto'
          });
          setArrowAbsolutePosition({
            placement: 'bottom',
            borderPosition: 'borderTop'
          });
          break;
        }
      case TooltipPosition.BOTTOM:
        {
          setTooltipAbsolutePosition({
            top: "".concat(childDimensions.height + 9, "px")
          });
          setArrowAbsolutePosition({
            placement: 'top',
            borderPosition: 'borderBottom'
          });
          break;
        }
      case TooltipPosition.LEFT:
        {
          setTooltipAbsolutePosition({
            right: "".concat(childDimensions.width + 9, "px"),
            left: 'auto'
          });
          setArrowAbsolutePosition({
            placement: 'right',
            borderPosition: 'borderLeft',
            left: 'auto'
          });
          break;
        }
      case TooltipPosition.RIGHT:
        {
          setTooltipAbsolutePosition({
            left: "".concat(childDimensions.width + 9, "px")
          });
          setArrowAbsolutePosition({
            placement: 'left',
            borderPosition: 'borderRight'
          });
          break;
        }
      default:
        {
          // TOP position
          setTooltipAbsolutePosition({
            bottom: "".concat(childDimensions.height, "px"),
            top: 'auto'
          });
          setArrowAbsolutePosition({
            placement: 'bottom',
            borderPosition: 'borderTop'
          });
        }
    }
  }, [tooltipPosition, childDimensions]);
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(TooltipContainer, {
    ref: tooltipRef,
    isVisible: !hidden && showTooltip,
    childDimensions: childDimensions,
    tooltipDimensions: tooltipDimensions,
    tooltipCoordinates: tooltipCoordinates,
    tooltipAbsolutePosition: tooltipAbsolutePosition
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    text: label,
    textSize: "p",
    fontColor: _color["default"].white,
    ellipsis: true
  }), /*#__PURE__*/_react["default"].createElement(Arrow, {
    ref: arrowRef,
    position: tooltipPosition,
    tooltipDimensions: tooltipDimensions,
    arrowCoordinates: arrowCoordinates,
    arrowAbsolutePosition: arrowAbsolutePosition
  })), /*#__PURE__*/_react["default"].createElement(ChildrenContainer, {
    ref: childRef
  }, children));
};
__signature__(Tooltip, "useState{[showTooltip, setShowTooltip](false)}\nuseState{[tooltipPosition, setTooltipPosition](TooltipPosition.TOP)}\nuseState{[arrowCoordinates, setArrowCoordinates]({ x: 0 })}\nuseState{[tooltipCoordinates, setTooltipCoordinates]({ x: 0 })}\nuseState{[tooltipDimensions, setTooltipDimensions]({ width: 0, height: 0 })}\nuseState{[childDimensions, setChildDimensions]({ width: 0, height: 0 })}\nuseState{[tooltipAbsolutePosition, setTooltipAbsolutePosition]({})}\nuseState{[arrowAbsolutePosition, setArrowAbsolutePosition]({})}\nuseRef{tooltipRef}\nuseRef{childRef}\nuseRef{arrowRef}\nuseEffect{}\nuseEffect{}\nuseEffect{}\nuseEffect{}");
Tooltip.defaultProps = {
  position: TooltipPosition.TOP,
  sticky: false,
  hidden: false
};
var _default = Tooltip;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(ChildrenContainer, "ChildrenContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(TooltipContainer, "TooltipContainer", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(Arrow, "Arrow", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(getValueInsideRange, "getValueInsideRange", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(TooltipPosition, "TooltipPosition", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(Tooltip, "Tooltip", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/WebComponents/Feedback/Tooltip.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();